import React from 'react';
import { RtModal } from '../../ui/RtModal';

const ConfirmAppTypeModal = ({ handleCancelAppType, handleConfirmAppType, appTypeLabel }) => {
  return (
    <RtModal
      open
      onClose={handleCancelAppType}
      title="Confirm application type"
      subtitle="This choice shapes the rest of your setup."
      size="sm"
      variant="confirm"
      footer={
        <>
          <button
            type="button"
            className="rt-btn rt-btn--secondary"
            onClick={handleCancelAppType}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rt-btn rt-btn--primary"
            onClick={handleConfirmAppType}
          >
            Yes, Continue
          </button>
        </>
      }
    >
      <div className="rt-modal-confirm">
        {appTypeLabel ? (
          <p className="rt-modal-confirm__entity">
            Selected type: <strong>{appTypeLabel}</strong>
          </p>
        ) : null}
        <p className="rt-modal-confirm__message">
          Once you select an application type and complete the setup,{' '}
          <strong>it cannot be changed later.</strong>
        </p>
        <p className="rt-modal__hint">
          Please make sure you are selecting the correct type for your project.
        </p>
      </div>
    </RtModal>
  );
};

export default ConfirmAppTypeModal;
